import formInput from '@/components/common/form-input/form-input.vue'
import formSelect from '@/components/common/form-select/form-select.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import backLink from '@/components/common/back-link/back-link.vue'
import Multiselect from 'vue-multiselect'
import { has } from 'lodash'
import router from '@/router'

import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    formInput,
    formSelect,
    formButton,
    backLink,
    Multiselect
  },
  data() {
    return {
      user: {
        role: 'user',
        piAccess: false,
        countries: [],
        email: '',
        name: ''
      },
      re: /..+@(?:warnermedia.com|turner.com|tectonicinteractive.com|wmcontractor.com|wbdcontractor.com|wbd.com)$/
    }
  },
  computed: {
    ...mapState('user', ['statuses', 'countriesList']),
    ...mapGetters('user', ['roles']),
    isOrdinaryUser: function () {
      return this.user.role !== 'superadmin'
    },
    isAllData: function () {
      const emailNameCheck = Boolean(this.user.name && this.re.test(this.user.email))
      if (this.isOrdinaryUser) {
        return Boolean(emailNameCheck && this.user.countries.length > 0)
      } else {
        return emailNameCheck
      }
    }
  },
  methods: {
    ...mapActions('user', ['createUser', 'getUsers', 'getCountriesList']),
    onCreateUser: async function () {
      if (this.isAllData) {
        const newUser = Object.assign({}, this.user)
        if (this.isOrdinaryUser) {
          newUser.country = this.user.countries.map((country) => country.id)
        } else {
          newUser.country = []
          newUser.piAccess = true
        }
        try {
          await this.createUser(newUser)
          this.$notify({
            text: 'User succesfully added',
            type: 'success'
          })
          router.push({ name: 'user-management' })
        } catch (err) {
          if (has(err, 'response.data.errorCode')) {
            const errorCode = err.response.data.errorCode
            if (errorCode === 'message_rejected') {
              this.$notify({
                text: 'Email address is not verified. Provide verified email address or contact administrator',
                type: 'error'
              })
            } else if (errorCode === 'duplicate_entry') {
              this.$notify({
                text: `Email ${newUser.email} already exists`,
                type: 'error'
              })
            } else {
              this.$notify({
                text: 'Error while adding the user',
                type: 'error'
              })
            }
          } else {
            this.$notify({
              text: 'Error while adding the user',
              type: 'error'
            })
          }
        }
      }
    }
  },
  created() {
    this.getCountriesList()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/user-management/user-add/user-add.js